/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import ScheduleStatusBadge from './ScheduleStatusBadge';
import {
   Row,
   RowMain,
   TripTitle,
   Meta,
   Stats,
   Stat,
   Chip,
   Chevron,
} from '../styles';
import {
   formatBRL,
   formatDateShort,
   formatOptimized,
   formatRelative,
   periodLabel,
} from '../helpers';

// Uma linha = uma roteirização (tripla data+período+base). Mapeamento campo→UI
// no handoff 0036 §3. Clique abre o board já escopado na tripla.
export default function ScheduleRow({ schedule, onOpen }) {
   const {
      schedule_date: date,
      schedule_period: period,
      cluster_origin: origin,
      total_items: totalItems,
      total_routed: totalRouted,
      total_unrouted: totalUnrouted,
      total_order_value: totalOrderValue,
      routes_count: routesCount,
      routes_active: routesActive,
      last_optimized_at: lastOptimizedAt,
      updated_at: updatedAt,
      derived_status: derivedStatus,
   } = schedule;

   const hasPending = Number(totalUnrouted) > 0;
   const baseLabel = origin?.label ?? origin?.code ?? '—';

   return (
      <Row
         $pending={hasPending}
         role="button"
         tabIndex={0}
         onClick={onOpen}
         onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
               e.preventDefault();
               onOpen();
            }
         }}
      >
         <RowMain>
            <TripTitle>
               <span className="trip">
                  {formatDateShort(date)} · {periodLabel(period)} · {baseLabel}
               </span>
               <ScheduleStatusBadge value={derivedStatus} />
            </TripTitle>
            <Meta>
               <span>{routesCount} rotas</span>
               <span className="sep">·</span>
               <span>{routesActive} ativas</span>
               <span className="sep">·</span>
               <span>{formatOptimized(lastOptimizedAt)}</span>
               <span className="sep">·</span>
               <span>atualizado {formatRelative(updatedAt)}</span>
            </Meta>
         </RowMain>

         <Stats>
            <Stat>
               <span className="v">
                  {totalRouted}/{totalItems}
               </span>
               <span className="l">Roteirizados</span>
            </Stat>
            <Chip $done={!hasPending}>{totalUnrouted} pendentes</Chip>
            <Stat>
               <span className="v">{formatBRL(totalOrderValue)}</span>
               <span className="l">Valor</span>
            </Stat>
         </Stats>

         <Chevron aria-hidden="true">›</Chevron>
      </Row>
   );
}

ScheduleRow.propTypes = {
   schedule: PropTypes.object.isRequired,
   onOpen: PropTypes.func.isRequired,
};
